import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const MapSection = () => {
  const handleMapClick = () => {
    window.open('https://www.google.com/maps/dir//Tecnote+-+R.+Targino+Cardoso+de+Ara%C3%BAjo,+n%C2%BA+23+-+Vila+Cristina,+S%C3%A3o+Jos%C3%A9+dos+Campos+-+SP,+12211-137/@-23.158122,-45.8934056,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x94cc4968e902523b:0xde98829a6984f3b2!2m2!1d-45.8912169!2d-23.158122!3e0', '_blank');
  };

  return (
    <section className="py-16 bg-blue-600 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full animate-bounce delay-1000" />
        <div className="absolute bottom-20 right-20 w-32 h-32 bg-white/5 rounded-full animate-pulse" />
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/10 rounded-full animate-ping delay-2000" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Visite a
              <span className="block text-yellow-400">Tecnote</span>
            </h2>
            
            <p className="text-xl text-blue-100 leading-relaxed">
              Venha conhecer nossa loja física em São José dos Campos. 
              Nossa equipe especializada está pronta para te atender!
            </p>

            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Endereço</h3>
                  <p className="text-blue-100">
                    Rua Targino Cardoso de Araujo, nº 23<br />
                    Vila Cristina - São José dos Campos - SP<br />
                    CEP: 12211-137
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <Navigation className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Como Chegar</h3>
                  <p className="text-blue-100">
                    Clique no mapa para abrir no Google Maps e<br />
                    receber direções para nossa loja
                  </p>
                </div>
              </div>
            </div>

            <button
              onClick={handleMapClick}
              className="bg-yellow-400 hover:bg-yellow-500 text-blue-600 px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <Navigation className="w-5 h-5 mr-2 inline" />
              Como Chegar
            </button>
          </div>

          {/* Right Content - Interactive Map */}
          <div className="relative">
            <div 
              className="relative bg-white rounded-2xl shadow-2xl overflow-hidden cursor-pointer group transform transition-all duration-300 hover:scale-105"
              onClick={handleMapClick}
            >
              {/* Map Container */}
              <div className="aspect-video relative">
                {/* Animated Marker */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                    {/* Pulsing Circle */}
                    <div className="absolute -inset-4 bg-blue-600/20 rounded-full animate-ping" />
                    <div className="absolute -inset-2 bg-blue-600/40 rounded-full animate-pulse delay-500" />
                    
                    {/* Main Marker */}
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center shadow-lg">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    
                    {/* Tecnote Label */}
                    <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-white px-3 py-1 rounded-full shadow-md">
                      <span className="text-blue-600 font-bold text-sm">Tecnote</span>
                    </div>
                  </div>
                </div>

                {/* Static Map Background */}
                <div 
                  className="w-full h-full bg-gradient-to-br from-blue-100 to-blue-200"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23dbeafe' fill-opacity='0.4'%3E%3Ccircle cx='50' cy='50' r='4'/%3E%3Ccircle cx='10' cy='10' r='4'/%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                  }}
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-blue-600/0 group-hover:bg-blue-600/10 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <div className="bg-white/90 px-4 py-2 rounded-lg shadow-lg">
                    <span className="text-blue-600 font-semibold">Clique para abrir no Google Maps</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Info Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-4 border-l-4 border-yellow-400">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" />
                <div>
                  <span className="text-sm font-semibold text-gray-700">Aberto Agora</span>
                  <p className="text-xs text-gray-500">Seg-Sex: 8h-18h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;